<section
  *ngIf="dataIsLoaded"
  class="boss-container"
  (deferLoad)="lazyLoad[0] = true"
  [ngStyle]="{ 'background-image': lazyLoad[0] ? 'url(' + data.image + ')' : '' }"
>
  <div class="boss-inner container p-3 p-md-5">
    <h2 [innerHTML]="data.heading" class="text-center"></h2>
    <p [innerHTML]="data.subheading" class="text-center"></p>
    <div [innerHTML]="data.text"></div>

    <ng-container *ngFor="let item of data.quotes">
      <div
        *ngIf="hasInnerText(item.quoteText)"
        class="quote-block d-flex align-contents-center flex-wrap flex-md-nowrap"
      >
        <div class="px-3 px-md-5 text-center text-md-right order-1 order-md-0">
          <p [innerHTML]="'&ldquo;' + item.quoteText + '&rdquo;'"></p>
          <small [innerHTML]="item.quoteAuthor"></small>
          <br />
          <small [innerHTML]="item.quoteTitle"></small>
        </div>
        <div *ngIf="hasInnerText(item.quoteImage)" class="boss-associate-image-container order-0 order-md-1">
          <img [src]="item.quoteImage" alt="" />
        </div>
      </div>
    </ng-container>
  </div>
</section>
